
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { TableList } from "../../../components";
import styles from './Donation.module.scss';
import common from '../../../common';

import CountUp from 'react-countup';

import axios from 'axios';

// import {
//     Chart as ChartJS,
//     CategoryScale, LinearScale, BarElement, LineElement, PointElement,
//     Tooltip, Legend, Filler, Title, ArcElement
// } from 'chart.js';
// import { Chart } from 'react-chartjs-2';
import 'chart.js/auto';                // ← 모든 차트 타입/스케일/엘리먼트/플러그인 자동 등록
import { Chart as ChartJS } from 'chart.js';
import { Chart } from 'react-chartjs-2';

const CenterTextPlugin = {
    id: 'centerText',
    afterDraw(chart, _args, opts) {
        const { ctx, chartArea: { width, height } } = chart;
        const text = opts?.text;
        if (!text) return;
        ctx.save();
        ctx.font = '600 16px system-ui, -apple-system, Segoe UI, Roboto';
        ctx.fillStyle = '#0d47a1';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y);
        ctx.restore();
    },
};
// ChartJS.register(
//     CategoryScale, LinearScale, BarElement, LineElement, PointElement,
//     Tooltip, Legend, Filler, Title, ArcElement, CenterTextPlugin, 
// );
// SliceLabelPlugin
ChartJS.register(CenterTextPlugin);

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



function Donation() {

    const { useAlert,useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    const [selectedData, setSelectedData] = useState([]);
    const [data , setData] = useState([]);
    
    const [activeTab, setActiveTab] = useState('onetime'); // onetime, recurring

    const categoryData = ['200'];

    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/naek_document/out/get_table`, {categoryData:categoryData}, {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data);
            } else {
                pAlert(response.data.msg);;
            }
        } catch (error) {
            console.error('Fetch failed:', error);
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const overviewRef = useRef(null);
    const forumHistoryRef = useRef(null);

    const columns = useMemo(() => [
        { title: '제목', dataIndex: 'title', className: 'p_td_title p_td_w_80' },
        { title: '날짜', dataIndex: 'createTime', className: 'p_td_date' },
    ], []);
    const pageSize = 10;
    const categoryOptions = useMemo(() => [
        { label: '전체', value: '전체' },
        { label: '제목', value: 'title' },
        { label: '내용', value: 'contents' },
    ], []);

    const [returnTableList, setReturnTableList] = useState(null);

    useEffect(() => {
        setReturnTableList(
            <TableList data={data} columns={columns} pageSize={pageSize} categoryOptions={categoryOptions} type="Editor" />
        );
    }, [columns, data, pageSize, categoryOptions]);


    const containerRef = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        // 모바일/터치 탐지 (여러 기준 중 하나라도 true면 모바일로 간주)
        const ua = navigator.userAgent || '';
        const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
        const isCoarse   = window.matchMedia?.('(pointer: coarse)').matches;
        const isSmall    = window.matchMedia?.('(max-width: 768px)').matches;
        const isMobile   = Boolean(isMobileUA || isCoarse || isSmall);

        // 모바일이거나 IO 미지원이면 즉시 true
        if (isMobile || !('IntersectionObserver' in window)) {
            setInView(true);
            return;
        }
        
        if (!containerRef.current) return;
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                setInView(true);   // 한 번만 재생
                io.disconnect();
                }
            },
            { threshold: 0.3 } // 20% 보이면 시작
        );
        io.observe(containerRef.current);
        return () => io.disconnect();
    }, []);

    const months = useMemo(
        () => ['5월','6월','7월','8월','9월','10월','11월','12월'],
        []
    );
    const numberFmt = (v) => v?.toLocaleString();
    const unitFmt = (v, unit) => `${numberFmt(v)}${unit || ''}`;

    const [ formData, setFormData ] = useState({//기본 설정
        totCount:0,
        totAmount:0,
        monthCount:0,
        monthAmount:0,
        monthsCount:[],
        monthsAmount:[],
        ldLabel:[],
        ldBarPack:[],
        ldDonutPack:[],
        mgLabel:[],
        mgDonutPack:[],
    });
    useEffect(() => {
        const fetchData_a = async () => {
            try {
                pLoadingOn();
                const response = await axios.post(`${API_BASE_URL}/naek_donation/out/get_data`, { code:'1' }, { withCredentials: true });
                if (response && response.data && response.data.result === 't') {
                    setFormData(prevData => ({
                        ...prevData,
                        totCount:response.data.tot_count_tot_amount.total_donor_count,
                        totAmount:response.data.tot_count_tot_amount.total_amount,
                        monthCount:response.data.month_count_month_amount.month_donor_count,
                        monthAmount:response.data.month_count_month_amount.month_amount,
                        monthsCount:response.data.months_count,
                        monthsAmount:response.data.months_amount,
                        ldLabel:response.data.letterDeparts_for_labels,
                        mgLabel:response.data.memberGrade_for_labels,
                        ldBarPack:response.data.letterDeparts_amount,
                        ldDonutPack:response.data.letterDeparts_amount,
                        mgDonutPack:response.data.memberGrades_amount,
                    }));
                } else {
                    console.error(response.data);
                    pAlert(response.data.msg);
                }
            } catch (error) {
                console.error('실패:', error);
            } finally {
                setTimeout(() => {
                    pLoadingOff();
                }, 300);
            }
        };
        fetchData_a();
    }, []);

    // 1) 월별 기부자수
    const donorsData = useMemo(() => {
        const byMonth = new Map(
            formData.monthsCount.map(({ month, donor_count }) => [Number(month), Number(donor_count) || 0])
        );

        const series = months.map(lbl => {
            const m = Number(String(lbl).replace(/[^0-9]/g, '')) || Number(lbl);
            return byMonth.get(m) ?? 0;
        });

        return {
            labels: months,
            datasets: [
            {
                type: 'bar',
                label: '',
                data: series,
                backgroundColor: '#1565c0',
                borderRadius: 4,
                maxBarThickness: 80,
            },
            ],
        };
    }, [months, formData.monthsCount]);

    const donorsOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: { display: false },
            title: { display: false, },
            tooltip: { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()} 명` } },
        },
        scales: {
            x: { grid: { display: false } },
            y:  { beginAtZero: true, ticks: { callback: v => Number(v).toLocaleString() } },
        },
        animation: inView ? { duration: 1000, easing: 'easeOutQuart' } : false,
    }), [inView]);


    // 2) 월별 기부금액 (막대 2종 + 선)
    const fundsData = useMemo(() => {
        const byMonth = new Map(
            formData.monthsAmount.map(({ month, amount }) => [Number(month), Number(amount) || 0])
        );

        const series = months.map(lbl => {
            const m = Number(String(lbl).replace(/[^0-9]/g, '')) || Number(lbl);
            return byMonth.get(m) ?? 0;
        });

        return {
            labels: months,
            datasets: [
            {
                type: 'bar',
                label: '',
                data: series,
                backgroundColor: '#4fc3f7',
                borderRadius: 4,
                maxBarThickness: 80,
            },
            ],
        };
    }, [months, formData.monthsAmount]);


    const fundsOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: { display: false, },
            title: { display: false, },
            tooltip: { callbacks: { label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()} 원` } },
        },
        scales: {
            x: { grid: { display: false } },
            y:  { stacked: true, beginAtZero: true, ticks: { callback: v => Number(v).toLocaleString() } },
        },
        animation: inView ? { duration: 1000, easing: 'easeOutQuart' } : false,
    }), [inView]);

    const letterdepart = useMemo(() => {
        if (!Array.isArray(formData.ldLabel)) return [];

        const seen = new Set();     // 중복 방지 (같은 이름이 여러 번 올 가능성 대비)
        const result = [];

        for (const row of formData.ldLabel) {
            if (!row) continue;

            const { letterDepartIDX, letterDepartName } = row;

            if (!letterDepartName) continue;
            if (seen.has(letterDepartName)) continue;

            seen.add(letterDepartName);
            result.push(letterDepartName); // 이름 그대로 사용 (정렬/가공 없음)
        }

        return result; // 예: ['재료자원공학','기계공학','전기전자공학', ...]
    }, [formData.ldLabel]);
    // 3) 분과별 기부금액 (막대 2종 + 선)
    const letterdepartData = useMemo(() => {
        // 1) 이름 → { amount, donor_count } 매핑
        const byName = new Map(
            (formData.ldBarPack ?? []).map(row => ([
                row.letterDepartName,
                {
                    amount: Number(row.amount) || 0,
                    donor_count: Number(row.donor_count) || 0,
                },
            ]))
        );

        // 2) 라벨 순서(letterdepart)에 맞춰 시리즈 생성
        const amountSeries = (letterdepart ?? []).map(name => byName.get(name)?.amount ?? 0);
        const donorSeries  = (letterdepart ?? []).map(name => byName.get(name)?.donor_count ?? 0);

        // (선택) 금액 단위를 바꾸고 싶으면 여기서 스케일링 (예: 100,000원을 1로)
        // const amountSeries = (letterdepart ?? []).map(name => (byName.get(name)?.amount ?? 0) / 100000);

        return {
            labels: letterdepart,
            datasets: [
                {
                    type: 'line',
                    label: '기부자 수',
                    data: donorSeries,
                    borderColor: '#f5a300',
                    borderWidth: 2,
                    tension: 0.3,
                    pointRadius: 3,
                    yAxisID: 'y1',
                },
                {
                    type: 'bar',
                    label: '기부금액',
                    data: amountSeries,
                    backgroundColor: '#1565c0',
                    stack: 'cash',
                    borderRadius: 4,
                    maxBarThickness: 80,
                },
            ],
        };
    }, [letterdepart, formData.ldBarPack]);

    const letterdepartOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            legend: { position: 'top' },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                label: (ctx) => `${ctx.dataset.label}: ${
                    Number(ctx.parsed.y).toLocaleString()
                }${ctx.dataset.type === 'line' ? ' 명' : ' 원'}`,
                    title: (items) => `${items[0].label}`,
                },
            },
        },
        scales: {
            x: { grid: { display: false } },
            y:  { stacked: true, beginAtZero: true, ticks: { callback: v => Number(v).toLocaleString() } },
            y1: { position: 'right', beginAtZero: true, grid: { drawOnChartArea: false },
            ticks: { callback: v => Number(v).toLocaleString() } },
        },
        animation: inView ? { duration: 1000, easing: 'easeOutQuart' } : false,
    }), [inView]);




    function dynamicColors(names) {
        const BASE = [
            '#1565c0','#1e88e5','#42a5f5','#64b5f6','#90caf9',
            '#0d47a1','#2a6fca','#7aa7e9','#b3d4fc','#034591',
            '#5b8def','#8fb7ff'
        ];
        if (names.length <= BASE.length) return BASE.slice(0, names.length);

        // 초과분은 라벨 해시로 HSL 생성(항목이 늘어도 같은 이름은 같은 색)..
        const toColor = (str) => {
            let h = 0;
            for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
            const hue = (h % 360 + 360) % 360;                         // 0~359
            return `hsl(${hue}, 60%, 55%)`;
        };
        return names.map((n, i) => BASE[i] ?? toColor(String(n)));
    }
    const doughnutAData = useMemo(() => {
        const rows = Array.isArray(formData.ldBarPack) ? formData.ldBarPack : [];

        // 라벨: 백엔드 순서 그대로
        const labels = rows.map(r => r.letterDepartName);

        // 퍼센트 데이터: amount_ratio_pct 우선, 없으면 amount로 계산
        const hasRatio = rows.every(r => r.amount_ratio_pct != null && r.amount_ratio_pct !== '');
        const data = hasRatio
            ? rows.map(r => Number(r.amount_ratio_pct) || 0)
            : (() => {
                const total = rows.reduce((s, r) => s + (Number(r.amount) || 0), 0);
                return rows.map(r => total ? ((Number(r.amount) || 0) / total) * 100 : 0);
            })();

        // 툴팁용 보조 데이터
        const donorCounts = rows.map(r => Number(r.donor_count) || 0);
        const amounts     = rows.map(r => Number(r.amount) || 0);

        const backgroundColor = dynamicColors(labels);

        return {
            labels,
            datasets: [{
                data,
                donorCounts,          // ← 툴팁에서 사용
                amounts,              // ← 툴팁에서 사용
                backgroundColor,
                hoverOffset: 6,
            }],
        };
    }, [formData.ldBarPack]);

    const doughnutAOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        cutout: '25%',
        plugins: {
            legend: { position: 'bottom' },
            title: { 
                display: false,
                text: '분과별 기부금액 비율'
            },
            tooltip: {
                callbacks: {
                    // 툴팁 제목: 분과명
                    title: (items) => items?.[0]?.label ?? '',
                    // 본문: 총 기부자 수, 총 기부금액, 퍼센테이지
                    label: (ctx) => {
                        const ds  = ctx.chart.data.datasets[ctx.datasetIndex];
                        const idx = ctx.dataIndex;

                        const donors = ds.donorCounts?.[idx] ?? null;
                        const amount = ds.amounts?.[idx] ?? null;

                        // 퍼센트 계산: data가 이미 %일 수도 있으므로 합이 100인지 확인
                        const val = Number(ctx.parsed) || 0;
                        const sum = (ds.data || []).reduce((a, b) => a + Number(b || 0), 0);
                        const pct = (sum > 0 && Math.abs(sum - 100) < 0.001)
                            ? val
                            : (sum > 0 ? (val / sum) * 100 : 0);

                        return [
                            `총 기부자 수: ${donors != null ? Number(donors).toLocaleString() + '명' : '-'}`,
                            amount != null
                                ? `총 기부금액: ${Number(amount).toLocaleString()}원 (${pct.toFixed(1)}%)`
                                : `총 기부금액: -`,
                        ];
                    },
                },
            },
        },
        animation: inView ? { duration: 900, easing: 'easeOutQuart' } : false,
    }), [inView]);




    const doughnutBData = useMemo(() => {
        // 예: formData.mgDonutPack = [{ amount, amount_ratio_pct, donor_count, memberGradeName(또는 memberGardeName) }, ...]
        const rows = Array.isArray(formData.mgDonutPack) ? formData.mgDonutPack : [];

        // 라벨: 백엔드 순서/이름 그대로 (키는 환경에 맞춰 사용)
        const labels = rows.map(r =>
            r.memberGradeName ?? r.memberGardeName ?? r.name ?? ''
        );

        // 데이터: 퍼센트(이미 %면 그대로, 아니면 amount 합으로 계산)
        const hasRatio = rows.every(r => r.amount_ratio_pct != null && r.amount_ratio_pct !== '');
        const data = hasRatio
            ? rows.map(r => Number(r.amount_ratio_pct) || 0)
            : (() => {
                const total = rows.reduce((s, r) => s + (Number(r.amount) || 0), 0);
                return rows.map(r => total ? ((Number(r.amount) || 0) / total) * 100 : 0);
            })();

        // 툴팁용 보조 데이터
        const donorCounts = rows.map(r => Number(r.donor_count) || 0);
        const amounts     = rows.map(r => Number(r.amount) || 0);

        const backgroundColor = dynamicColors(labels); // 또는 기존 dynamicColors(labels)

        return {
            labels,
            datasets: [{
                data,
                donorCounts,     // 툴팁에서 사용
                amounts,         // 툴팁에서 사용
                backgroundColor,
                hoverOffset: 6,
            }],
        };
    }, [formData.mgDonutPack]);

    const doughnutBOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        cutout: '25%',
        plugins: {
            legend: { position: 'bottom' },
            title: { 
                display: false,
                text: '회원구분별 기부금액 비율'
            },
            tooltip: {
                callbacks: {
                    // 툴팁 제목: 회원구분명
                    title: (items) => items?.[0]?.label ?? '',
                    // 본문: 총 기부자 수 / 총 기부금액 / 퍼센테이지
                    label: (ctx) => {
                        const ds  = ctx.chart.data.datasets[ctx.datasetIndex];
                        const idx = ctx.dataIndex;

                        const donors = ds.donorCounts?.[idx] ?? null;
                        const amount = ds.amounts?.[idx] ?? null;

                        const val = Number(ctx.parsed) || 0;
                        const sum = (ds.data || []).reduce((a, b) => a + Number(b || 0), 0);
                        const pct = (sum > 0 && Math.abs(sum - 100) < 0.001)
                            ? val
                            : (sum > 0 ? (val / sum) * 100 : 0);

                        return [
                            `총 기부자 수: ${donors != null ? Number(donors).toLocaleString() + '명' : '-'}`,
                            amount != null
                                ? `총 기부금액: ${Number(amount).toLocaleString()}원 (${pct.toFixed(1)}%)`
                                : `총 기부금액: -`,
                        ];
                    },
                },
            },
            // sliceLabel 등을 쓰고 있으면 여기서 옵션 추가 가능
        },
        animation: inView ? { duration: 900, easing: 'easeOutQuart' } : false,
    }), [inView]);

    const numberStyle = { fontSize: 48, fontWeight: 800, color: '#ffffff', lineHeight: 1 };

    return (
        <>
            <div className="components_wrap">
                <div className={styles.cont_wrap}>
                    <div className={styles.cont_tit_box}>
                        <span>기부금기부금 안내</span>
                    </div>
                    <div className={styles.cont_box}>
                        <ul className={styles.bul_list}>
                            <li>한국공학한림원은 공학기술의 발전과 산업 진흥을 위해 일시기부와 정기기부를 통해 후원금을 기부금하고 있습니다. 여러분께서 출연해 주신 기부금은 아래의 사업에 소중히 사용됩니다.</li>
                        </ul>
                        <ul className={styles.bul_list_3}>
                            <li><b>일시기부(공학한림원 미래 30년을 위한 기부금)</b> : 공학 싱크탱크 활동을 위한 후원, 최고경영인평의회 활동 후원, 신축회관 건립 후원, 30주년기념사업 후원</li>
                            <li><b>정기기부</b> : 정책연구, 우수 공학인 포상, 공학문화 확산 후원(주니어공학기술교실, 도서 출판 및 배포 등)</li>
                        </ul>
                    </div>
                </div>
                <div className={styles.tab_btn_box}>
                    <button
                        className={[
                            styles.tab_btn,
                            activeTab === 'onetime' && styles.active
                            ].filter(Boolean).join(' ')}
                        onClick={() => setActiveTab('onetime')}
                    >일시기부[공학한림원 미래 30년을 위한 기부]</button>
                    <button
                        className={[
                            styles.tab_btn,
                            activeTab === 'recurring' && styles.active
                            ].filter(Boolean).join(' ')}
                        onClick={() => setActiveTab('recurring')}
                    >정기기부</button>
                </div>

                {activeTab === 'onetime' && (
                    <div className={styles.n30th_wrap}>
                        <div className={styles.n30th_top_wrap}>
                            <div className={styles.n30th_bg}></div>
                            <div className={styles.n30th_top_box}>
                                <span className={styles.n30th_t_left_txt}>한국공학한림원 미래 30년을 위한 기부금 모집</span>
                                <span className={styles.n30th_t_right_sb}></span>
                            </div>
                            <div className={styles.n30th_middle_txt}></div>
                            <div className={styles.n30th_bottom_box}>
                                <span>올해로 30번째 생일을 맞은 한국공학한림원은<br />
                                지난 30년간 공학한림원이 걸어온 발자취를 기념하고, 향후 30년을 향해 나아가기 위한 기부금을 모집합니다.
                                회원 여러분의 많은 참여를 부탁드립니다.</span>
                            </div>
                            <div className='flex_center '>
                                <button
                                    className="p_btn p_btn_normal"
                                    onClick={() => window.open('https://secure.donus.org/naek30th/', '_blank')}
                                    >온라인 기부 바로가기</button>
                            </div>
                        </div>

                        <div className={`${styles.n30_line_1} `}></div>




                        <div className={`${styles.n30_contenst_wrap} `}>
                            <div className={`${styles.n30_c_top_stat_box} `}>
                                <div className={`${styles.n30_c_t_s_left_box} `}>
                                    <div className={`${styles.n30_c_t_s_row} `}>
                                        <div className={`${styles.n30_c_t_s_tit_box} `}>
                                            <img className={`${styles.n30_c_t_s_i}`} src="/img/donation/do_i_1_w30.png" alt="" />
                                            <span className={`${styles.n30_c_t_s_tit} `}>총 기부자수</span>
                                        </div>
                                        <div className={`${styles.n30_c_t_s_con_box} `}>
                                            <div className={`${styles.n30_CountUp_box} `} >
                                                <CountUp
                                                    end={formData.totCount}
                                                    duration={1.4}
                                                    separator=","
                                                    // suffix="명"
                                                    enableScrollSpy   // 뷰포트에 보일 때 시작
                                                    scrollSpyDelay={100} // 보정 딜레이(ms)
                                                />
                                            </div>
                                            <span className={`${styles.n30_CountUp_suffix} `}>명</span>
                                        </div>
                                    </div>
                                    <div className={`${styles.n30_c_t_s_row} `}>
                                        <div className={`${styles.n30_c_t_s_tit_box} `}>
                                            <img className={`${styles.n30_c_t_s_i}`} src="/img/donation/do_i_2_w30.png" alt="" />
                                            <span className={`${styles.n30_c_t_s_tit} `}>총 기부금액</span>
                                        </div>
                                        <div className={`${styles.n30_c_t_s_con_box} `}>
                                            <div className={`${styles.n30_CountUp_box} `} >
                                                <CountUp
                                                    end={formData.totAmount}
                                                    duration={1.6}
                                                    separator=","
                                                    // suffix="명"
                                                    enableScrollSpy   // 뷰포트에 보일 때 시작
                                                    scrollSpyDelay={100} // 보정 딜레이(ms)
                                                />
                                            </div>
                                            <span className={`${styles.n30_CountUp_suffix} `}>원</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.n30_c_t_s_right_box} `}>
                                    <span className={`${styles.n30_c_sec_tit} `}>11월 기부금현황</span>
                                    <div className={`${styles.n30_c_t_s_r_con_box} `}>
                                        <div className={`${styles.n30_c_t_s_row} `}>
                                            <div className={`${styles.n30_c_t_s_tit_box} `}>
                                                <span className={`${styles.n30_c_t_s_tit} `}>기부자수</span>
                                            </div>
                                            <div className={`${styles.n30_c_t_s_con_box} `}>
                                                <div className={`${styles.n30_CountUp_box} `} >
                                                    <CountUp
                                                        end={formData.monthCount}
                                                        duration={1.4}
                                                        separator=","
                                                        // suffix="명"
                                                        enableScrollSpy   // 뷰포트에 보일 때 시작
                                                        scrollSpyDelay={100} // 보정 딜레이(ms)
                                                    />
                                                </div>
                                                <span className={`${styles.n30_CountUp_suffix} `}>명</span>
                                            </div>
                                        </div>
                                        <div className={`${styles.n30_c_t_s_row} `}>
                                            <div className={`${styles.n30_c_t_s_tit_box} `}>
                                                <span className={`${styles.n30_c_t_s_tit} `}>기부금액</span>
                                            </div>
                                            <div className={`${styles.n30_c_t_s_con_box} `}>
                                                <div className={`${styles.n30_CountUp_box} `} >
                                                    <CountUp
                                                        end={formData.monthAmount}
                                                        duration={1.6}
                                                        separator=","
                                                        // suffix="명"
                                                        enableScrollSpy   // 뷰포트에 보일 때 시작
                                                        scrollSpyDelay={100} // 보정 딜레이(ms)
                                                    />
                                                </div>
                                                <span className={`${styles.n30_CountUp_suffix} `}>십만원</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.n30_c_chart_wrap} `} ref={containerRef}>
                                <div className={`${styles.n30_c_chart_sec} `}>
                                    <span className={`${styles.n30_c_sec_tit} `}>월별 기부금현황 <font className={`${styles.n30_c_sec_tit_sub} `}>( 2025.05.01 ~ 2025.11.16 )</font> </span>
                                    <div className={`${styles.n30_c_chart_row} `}>
                                        <div className={`${styles.n30_c_chart_box} `}>
                                            <span className={`${styles.n30_c_c_b_tit} `}>월별 기부자수</span>
                                            <div className={`${styles.n30_c_chart} `} style={{ height: 360 }}>
                                                {inView && (
                                                    <Chart
                                                    key="donors"          // 리마운트로 초기 애니메이션 보장
                                                    type="bar"
                                                    data={donorsData}
                                                    options={donorsOptions}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className={`${styles.n30_c_chart_box} `}>
                                            <span className={`${styles.n30_c_c_b_tit} `}>월별 기부금액</span>
                                            <div className={`${styles.n30_c_chart} `} style={{ height: 360 }}>
                                                {inView && (
                                                    <Chart
                                                    key="funds"
                                                    type="bar"
                                                    data={fundsData}
                                                    options={fundsOptions}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.n30_c_chart_sec} `}>
                                    <span className={`${styles.n30_c_sec_tit} `}>분과별 기부현황</span>
                                    <div style={{ height : '20px' }}></div>
                                    <div className={`${styles.n30_c_chart_box} ${styles.n30_c_chart_box_full}`}>
                                        <div className={`${styles.n30_c_chart} `} style={{ height: 360 }}>
                                            {inView && (
                                                <Chart
                                                key="letterdepart"          // 리마운트로 초기 애니메이션 보장
                                                type="bar"
                                                data={letterdepartData}
                                                options={letterdepartOptions}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ height : '20px' }}></div>
                                <div className={`${styles.n30_c_chart_sec} `}>
                                    <div className={`${styles.n30_c_chart_row} `}>
                                        <div className={`${styles.n30_c_chart_box} ${styles.n30_c_chart_box_donut}`}>
                                            <span className={`${styles.n30_c_c_b_tit} `}>분과별 기부금액 비율</span>
                                            <div className={`${styles.n30_c_chart} `} style={{ height: 500 }}>
                                                {inView && (
                                                    <Chart
                                                        key="donut-a"
                                                        type="doughnut"
                                                        data={doughnutAData}
                                                        options={{
                                                            ...doughnutAOptions,
                                                            plugins: { ...doughnutAOptions.plugins, centerText: { text: '' } },
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className={`${styles.n30_c_chart_box} ${styles.n30_c_chart_box_donut}`}>
                                            <span className={`${styles.n30_c_c_b_tit} `}>회원구분별 기부금액 비율</span>
                                            <div className={`${styles.n30_c_chart} `} style={{ height: 500 }}>
                                                {inView && (
                                                    <Chart
                                                        key="donut-b"
                                                        type="doughnut"
                                                        data={doughnutBData}
                                                        options={{
                                                            ...doughnutBOptions,
                                                            plugins: { ...doughnutBOptions.plugins, centerText: { text: '' } },
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )}







                {activeTab === 'recurring' && (
                    <>
                    <div className='mgt20'><br /></div>
                    <div className={styles.cont_wrap}>
                        <div className={styles.cont_tit_box}>
                            <span>정기기부 안내</span>
                        </div>
                        <div className={styles.cont_box}>
                            <ul className={styles.bul_list}>
                                <li>한국공학한림원이 공학기술계를 대표하는 단체로서 정치적 중립을 유지하고 건전한 정책제언을 지속하기 위해서는 독립적인 예산의 확보가 필요합니다.</li>
                                <li>여러분께서 출연해 주시는 기금은 공학한림원의 각종사업 중에서 선택하여 후원할 수 있으며, 지정기부금 영수증을 발급하여 드립니다.</li>
                            </ul>
                        </div>
                    </div>

                    <div className={styles.cont_wrap}>
                        <div className={styles.cont_tit_box}>
                            <span>정보</span>
                        </div>
                        <div className={styles.cont_box}>
                            <ul className={styles.bul_list_2}>
                                <li><b>문의처 : </b>한국공학한림원 사무처</li>
                                <li><b>전화 : </b>02-6009-4000</li>
                                <li><b>이메일 : </b>naek@naek.or.kr</li>
                                <li><b>입금계좌 : </b>기업은행 449-000014-04-013 (예금주 : 한국공학한림원)</li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.cont_wrap}></div>
                    <div className={styles.cont_wrap}>
                        <div className={styles.cont_tit_box}>
                            <span>기부금 현황</span>
                        </div>
                    </div>
                    {returnTableList}
                    </>
                )}

            </div>
        </>
    );
}

export default Donation;